import axios from 'axios';

const GET_SALES_ORDER = '/.netlify/functions/salesOrderGetSalesOrder';

import { TOKEN_EXPIRED, TIMEOUT, INTERNAL_ERROR } from "../hooks/useAPIHelper";

const SalesOrderGetSalesOrder = async (filter: string, token: string, selectedCustomerId: string) => {

  const fetchData = async () => {
    try {
      let salesOrderResponse = await axios.post(
        GET_SALES_ORDER,
        `<Parameters>${filter}</Parameters>`,
        {
          headers: {
            'Content-Type': 'application/xml',
            'X-Pronto-Token': token,
          }
        }
      );

      if(salesOrderResponse != undefined) {
        return salesOrderResponse.data.SalesOrderGetSalesOrdersResponse.SalesOrders.SalesOrder;
      }

    } catch (err) {
      console.log(err);
      if(err.response.status == 504) {
        throw(TIMEOUT);
      } else if(err.response.status == 500) {
        throw(INTERNAL_ERROR);
      } else if(err.response.status == 401) {
        if(err.response.data == 'TokenExpired') {
          throw(TOKEN_EXPIRED)
        }
      }
    }
  };

  return await fetchData();
};

export default SalesOrderGetSalesOrder